import request from '@/utils/request'
import { message } from 'ant-design-vue'

export function fileupload(data) {
  return request({
    url: 'admin/sys/minio/upload',
    method: 'post',
    headers: {'Content-Type': 'multipart/form-data'},
    data
  })
}
export function fileListupload(data) {
  return request({
    url: 'admin/sys/minio/uploadList',
    method: 'post',
    headers: {'Content-Type': 'multipart/form-data'},
    data
  })
}

export function getlistObjects(data,bucketName) {
  return request({
    url: 'admin/sys/minio/getlistObjects',
    method: 'post',
    data,
    bucketName
  })
}

export function delBybucketName(data,bucketName) {
  return request({
    url: 'admin/sys/minio/delete/'+data+"/"+bucketName,
    method: 'get'
  })
}
export function dels(data,bucketName) {
  return request({
    url: 'admin/sys/minio/deletes' ,
    method: 'post' ,
    data,
    bucketName
  })
}

export function download(data,bucketName) {
  message.info('文件开始下载')
  return request({
    url: 'admin/sys/minio/download/'+data+"/"+bucketName,
    method: 'get'
  })
}

export function preViewPicture(data,bucketName) {
  return request({
    url: 'admin/sys/minio/preViewPicture/'+data+"/"+bucketName,
    method: 'get'
  })
}

export function getObjectURL(bucketName,data,expires) {
  return request({
    url: 'admin/sys/minio/getObjectURL/'+bucketName+"/"+data+"/"+expires,
    method: 'get'
  })
}

export function getFiles(bucketName,data) {
  return request({
    url: 'admin/sys/minio/getObjectURL/'+bucketName+"/"+data,
    method: 'get'
  })
}